var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            visible: _vm.forgetDialogVisible,
            width: "480px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.forgetDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "password-container-forget" },
            [
              _vm.isEditPassword
                ? _c("div", { staticClass: "forget-text" }, [
                    _vm._v(" " + _vm._s(_vm.$t("home.forgetPassword"))),
                  ])
                : _c("div", { staticClass: "forget-text" }, [
                    _vm._v(" " + _vm._s(_vm.$t("home.forgetAccount"))),
                  ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "forget-form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.loginRules,
                    autocomplete: "on",
                    "label-position": "top",
                  },
                },
                [
                  _c("el-form-item"),
                  _vm._v(" "),
                  _vm.isEditPassword
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "accountNo",
                            label: _vm.$t("home.account"),
                          },
                        },
                        [
                          _c("el-input", {
                            directives: [
                              { name: "trim", rawName: "v-trim" },
                              { name: "fth", rawName: "v-fth" },
                            ],
                            ref: "accountNo",
                            style: "width: 100%",
                            attrs: {
                              autocomplete: "on",
                              name: "accountNo",
                              type: "text",
                              tabindex: "1",
                              maxlength: "30",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleLogin($event)
                              },
                            },
                            model: {
                              value: _vm.form.accountNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "accountNo", $$v)
                              },
                              expression: "form.accountNo",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("home.email"),
                        prop: "activateEmail",
                      },
                    },
                    [
                      _c("el-input", {
                        directives: [
                          { name: "uppercase", rawName: "v-uppercase" },
                          { name: "trim", rawName: "v-trim" },
                          { name: "fth", rawName: "v-fth" },
                        ],
                        style: "width: 100%",
                        model: {
                          value: _vm.form.activateEmail,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "activateEmail", $$v)
                          },
                          expression: "form.activateEmail",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sure-button" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "submitBtn",
                      staticStyle: { width: "20%", background: "#fff" },
                      nativeOn: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.handleClose($event)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("home.buttonClose")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "submitBtn",
                      staticStyle: { width: "20%", background: "#0099e5" },
                      attrs: { type: "primary" },
                      nativeOn: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.handleResetPassword($event)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("home.sentEmail")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("slideLogin", {
            ref: "slideLogin",
            attrs: { showData: _vm.showData },
            on: { submit: _vm.submitLoginCode },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }